<template>
  <div class="villabox" @click="$root.$emit('lightboxevent', { imagelist: v.imagelist, caption: v.name })">
      <div class='title'>
          <div class='text'>{{ v.name }} </div>
      </div>
      <div class='info'>
          <div class='infonum'>{{ v.beds }}</div>
          <font-awesome-icon :icon="faBed" /> 
          <div class='infonum'>{{ v.bath }}</div>
          <font-awesome-icon :icon="faBath" /> 
          <div class='infonum'>{{ v.person }}</div>
          <font-awesome-icon :icon="faUserFriends" /> 
          <div v-if='v.pool === "Private"' class='infotext'>Private Pool</div>
      </div>
      <div class="pic">
          <img :src='v.preferred.img'>
      </div>
  </div>
</template>
<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import faUserFriends from '@fortawesome/fontawesome-free-solid/faUserFriends'
import faBed from '@fortawesome/fontawesome-free-solid/faBed'
import faBath from '@fortawesome/fontawesome-free-solid/faBath'

export default {
  props: ['v'],
  data () {
    return { faUserFriends, faBed, faBath }
  },
  components: {
    FontAwesomeIcon
  }
}
</script>

<style lang="less" scoped>
@import "../css/globals.less";

div.villabox {
  flex: 1 0 200;
  position: relative;
  cursor: pointer;
  margin: 1em;
}

div.villabox div.title {
  position: absolute;
  left: 0;
  padding: 0.4em 0 0.4em 1.2em;
  top: 0em;
  right: 0;
  height: 1em;
  background-color: rgb(224, 191, 120);
  color: black;
  opacity: 0.85;
  font-size: @default-font-size * 1.3;
}

div.villabox div.title div.text {
  opacity: 1;
}

div.villabox div.info {
  position: absolute;
  padding: 0.3em;
  right: 0em;
  bottom: 1.8em;
  height: 1em;
  background-color: white;
  opacity: 0.75;
  font-size: 12pt;
  border-radius: 0.5em 0em 0em 0.5em;
  font-family: @serif-font;
  display: flex;
  justify-content: center;
  align-items: center;
}

div.villabox div.info > img {
  width: 1em;
  padding: 0;
  display: inline-block;
  height: 1em;
  margin: auto;
  opacity: 1;
}

div.villabox div.info div.infonum {
  padding: 0 0.3em;
}

div.villabox div.info div.infonum,
div.villabox div.info div.infotext {
  opacity: 1;
  padding: 0 0.3em;
  display: inline-block;
}

div.villabox div.pic > img {
  width: 100%;
  object-fit: contain;
}
</style>


// WEBPACK FOOTER //
// src/components/VillaBox.vue